import { confirmDialog, type SettingsRow } from '@bn-games/ui-shell';
import { buildSettingsRows, type SettingsRowCtx } from './settingsRows.js';
import { t } from '../i18n/I18n.js';

export interface InGameSettingsOptions {
  readonly ctx: SettingsRowCtx;
  readonly isOnline: () => boolean;
  readonly restartMatchOffline: () => void;
}

/**
 * In-game variant of the settings row set. Wraps difficulty / variant /
 * defaultColor changes with a discard-confirm dialog that restarts the
 * local match. Online matches keep those rows visible but disabled.
 */
export function buildInGameSettingsRows(
  opts: InGameSettingsOptions,
): readonly SettingsRow[] {
  const online = opts.isOnline();
  return buildSettingsRows({
    ctx: opts.ctx,
    disableGameConfig: online,
    onGameConfigChange: online
      ? undefined
      : (apply) => {
          void confirmDialog({
            title: t('gameOverlay.discardConfirmTitle'),
            message: t('gameOverlay.discardConfirmBody'),
            confirmLabel: t('gameOverlay.discardConfirmYes'),
            cancelLabel: t('gameOverlay.discardConfirmNo'),
            danger: true,
          }).then((ok) => {
            if (!ok) return;
            apply();
            opts.restartMatchOffline();
          });
        },
  });
}
